import React, {useContext, useEffect} from 'react';
import { OverviewContext } from '../context/OverviewProvider';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Model from '../../components/UI/Modal/Model';
import OverviewHeader from '../components/OverviewHeader/OverviewHeader';
import OverviewFooter from '../components/OverviewFooter/OverviewFooter';
import Overview from '../../components/UI/Overview/Overview';
import OverviewDetailHeader from '../components/OverviewDetailHeader/OverviewDetailHeader';
import OverviewDetails from '../components/OverviewDetails/OverviewDetails';
import UnsubmittedOverviewDetails from '../components/OverviewDetails/UnsubmittedOverviewDetails';
import Spinner from '../../components/UI/Spinner/Spinner';
import UploadFileModel from '../../components/UI/UploadFile/UploadFileModal'
import IdleTimerContainer from '../../containers/IdleTimer/IdleTimerContainer';
import {OverviewDetailsOptions} from '../../common/const/OverviewDetailsOptions';
import './index.css';
import PendingCrStatus from '../../containers/PendingCrStatus/PendingCrStatus';

function UserOverview(props) {

    const {fromMinDate, fromRevenueDate, fromMaxDate, untilMinDate, untilRevenueDate, untilMaxDate, sessionTimeoutLimit,
           idleTimeoutLimit, fromDateHandler, untilDateHandler, overview, isError, isLoading, errorMessage, 
           overviewDataSelectionHandler, isBtnDetailsEnable, isShowDetailsClicked, 
           overviewDetails, handlerOnShowDetail, handlerOnBackBtnClick, isEditAccess, isEditBtnToggle, isEnableEditableFields,
           handlerOnEditBtnClick,handlerOnEditBtnToggleClick, setOverviewRevenueData, isSuccessfullySaved, showModel, showInstructions,
           modelHeaderTitle, selectedRevenue, selectedRevenueId, showUploadFileModel, acceptFileType,
           isFileUploadedSuccessfully, handlerResetUpdatedAndErrorFlags, handlerOnSaveClick, showInstructionsHandler,
           handleConfirmationYesClick, handlerOnDownloadCashRegisterClick, handlerOnCashRegisterIconClick,
           handlerOnUploadCashRegisterClick, handlerToShowUnsavedChanges, handlerOnLogout, selectedOverdetailsOption, remarksOptions,cashRegisterMandatory} = useContext(OverviewContext);

   
           useEffect(() => {                    
            if(props.isLogout)
             {              
                let isUpdated = false;              
                overviewDetails.nmbsUserDetailOverviewDtos && overviewDetails.nmbsUserDetailOverviewDtos.map((d, index) => {
                if (isUpdated === false && d.isUpdated) {
                        isUpdated = d.isUpdated;
                  }
                });

                if (isUpdated === true) {
                    handlerToShowUnsavedChanges(); 
                }
                else {                
                    props.clearSessionData();
                    props.setLogoutFalse(); 
                    }                
             }
            }, [props.isLogout]);  
           
    const  onModelNoClickHandler = () => {                
            handlerResetUpdatedAndErrorFlags();  
            props.setLogoutFalse();   
    }

    const  onModelYesClickHandler = () => {           
            if(props.isLogout)
             {
                props.setLogoutFalse();                               
                props.clearSessionData();
                handlerOnLogout();                
             }
             else
             {
              handleConfirmationYesClick();
             }             
    }       
    
    const isSubmittedRevenue = selectedOverdetailsOption === OverviewDetailsOptions.submittedRevenue;
    return(  
        <div className="sidebar-bottomcontent-container">
        <div className="sidebar-bottomcontent-container-row">
        {props.showUnblockModel ? <PendingCrStatus setShowUnblockModel={props.setShowUnblockModel} 
                                                    showUnblockModel={props.showUnblockModel}/> : null}
                
        <div className="sidebar-bottomcontent-container-col"><></></div>
        <div className="sidebar-bottomcontent-container-next-col">
            <div className="main-contents">    
                <div className="main-content">  
                    <div className="nmbs-main">
                        <Container>
                            {!isShowDetailsClicked ? <Row className={ fromRevenueDate ? 
                                "Overview-header-row" : "Overview-header-row Overview-header-row-transparent"} >
                                    { fromRevenueDate && untilRevenueDate && <OverviewHeader                        
                                        isOverviewDataAvailable={overview && overview.length > 0}  
                                    /> }
                                    </Row>
                                : 
                                    <Row md={1} className="OverviewDetail-header-row">
                                        { <OverviewDetailHeader 
                                            isEnableEditableFields={isEnableEditableFields} 
                                            handlerOnEditBtnClick={handlerOnEditBtnClick}
                                            handlerOnEditBtnToggleClick = {(e) => handlerOnEditBtnToggleClick(e)}
                                            isEditAccess={isEditAccess}
                                            isEditBtnToggle = {isEditBtnToggle}
                                            handlerOnSaveClick={handlerOnSaveClick}
                                            showInstructionsHandler = {showInstructionsHandler}
                                            UserId={props.UserId}                                
                                            isOverviewDetailsAvailable={overviewDetails && overviewDetails.nmbsUserDetailOverviewDtos && 
                                                                    overviewDetails.nmbsUserDetailOverviewDtos.length > 0}                               
                                                                    /> }
                                    </Row>
                                }    
                                {!isShowDetailsClicked ? <Row className="Overview-data-row">
                                    { fromRevenueDate && untilRevenueDate ?
                                            // !isLoading ?
                                            <>
                                                <div>
                                                    {overview && <Overview 
                                                        overview={overview}
                                                        overviewDataSelectionHandler={overviewDataSelectionHandler} 
                                                        isError={isError}
                                                        isBtnDetailsEnable={isBtnDetailsEnable}
                                                        errorMessage={errorMessage} 
                                                        onShowDetailClick={handlerOnShowDetail}
                                                    />}
                                                </div>
                                                {isLoading ? <Spinner isLogin = {false}/> : undefined}
                                            </>
                                        : undefined
                                    }
                                    </Row>
                                :   <Row className="Overviewdetail-data-row">
                                        {
                                            // !isLoading ? 
                                        overviewDetails && remarksOptions ? 
                                            ( <>
                                                <div> 
                                                {isSubmittedRevenue ? <OverviewDetails 
                                                    overviewDetails={overviewDetails}
                                                    onBackButtonClick={(e) => handlerOnBackBtnClick(e)}
                                                    isEditAccess={isEditAccess}
                                                    isEnableEditableFields={isEnableEditableFields} 
                                                    setOverviewRevenueData={setOverviewRevenueData}
                                                    DownloadCashRegister={handlerOnDownloadCashRegisterClick}
                                                    handlerOnCashRegisterIconClick={handlerOnCashRegisterIconClick}
                                                    isUnSubmittedRevenue={selectedOverdetailsOption === OverviewDetailsOptions.unsubmittedRevenue}
                                                    remarksOptions ={remarksOptions}
                                                    cashRegisterMandatory = {cashRegisterMandatory}
                                                    /> : <UnsubmittedOverviewDetails overviewDetails={overviewDetails}
                                                        onBackButtonClick={(e) => handlerOnBackBtnClick(e)}/>}
                                                <Model showModel={showModel} 
                                                    onHideHandler={onModelNoClickHandler}
                                                    showHeader={showModel}
                                                    showInstructions = {showInstructions}
                                                    headerTitle={modelHeaderTitle}
                                                    showSuccess={isSuccessfullySaved || isFileUploadedSuccessfully}
                                                    successMessage={isSuccessfullySaved ? "DetailsUpdatedSuccessfully"
                                                                    : isFileUploadedSuccessfully ? "cashregisteruploadedsuccessfully" : ""}
                                                    showError={isError}
                                                    errorMessage={errorMessage}
                                                    handleConfirmationYesClick={onModelYesClickHandler}
                                                    isBusinessPartner = {false}
                                                />
                                                {showUploadFileModel &&
                                                    <UploadFileModel showModel={showUploadFileModel}
                                                        acceptFileType={acceptFileType}
                                                        showHeader={showUploadFileModel}
                                                        onHideHandler={handlerResetUpdatedAndErrorFlags}
                                                        headerTitle={modelHeaderTitle}
                                                        handlerOnUploadClick={handlerOnUploadCashRegisterClick}
                                                        isCashRegister={true}
                                                        allowedFileType={"fileformat"}
                                                        selectedRowIndex={selectedRevenueId}
                                                        selectedRevenue={selectedRevenue}
                                                        selectedRevenueCashRegisterFile={null}
                                                        handlerOnDeleteFileClick={null}  
                                                        UserId={props.UserId}
                                                        isModifying={true}
                                                    />
                                                }
                                                </div>
                                                {isLoading ? <Spinner isLogin = {false}/> : undefined}
                                            </>)
                                            : undefined
                                        // : ((isLoading ) ? <Spinner /> : undefined)
                                        }
                                </Row> } 
                                {!isShowDetailsClicked ? <Row className={ fromRevenueDate ? 
                                    "Overview-header-row" : "Overview-header-row Overview-header-row-transparent"} >
                                    { fromRevenueDate && untilRevenueDate && <OverviewFooter
                                        fromMinDate= {fromMinDate} 
                                        fromRevenueDate= {fromRevenueDate} 
                                        fromMaxDate= {fromMaxDate}
                                        untilMinDate= {untilMinDate} 
                                        untilRevenueDate= {untilRevenueDate}
                                        untilMaxDate= {untilMaxDate}
                                        onFromDateChange = {fromDateHandler}
                                        onUntilDateChange={untilDateHandler}
                                        isError={isError}
                                        errorMessage={errorMessage}  /> }
                                    </Row>
                                    : undefined} 
                        </Container>
                        {sessionTimeoutLimit && idleTimeoutLimit && <IdleTimerContainer idleTimeoutLimit={1000*idleTimeoutLimit} 
                                                                    sessionTimeoutLimit={1000*sessionTimeoutLimit} 
                                                                    logout={props.onLogoutClick} /> }
                                                                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>    
    );
}
export default UserOverview;